import { FormBuilder } from '@angular/forms';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';

export class DemoSettingsDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        { name: 'ageMax', type: 'number', defaultValue: 11 },
        { name: 'ageMin', type: 'number', defaultValue: 1 },
        { name: 'gender', type: 'Array<string>', defaultValue: [] },
        { name: 'measurementVendor', type: 'any' },
        { name: 'onTargetGoal', type: 'number' }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}
